module.exports = __webpack_public_path__ + "img/main-hero-1.8da94287.jpg";